export default {
    'diagram3b2-3': {
        'diagram-task': 'Q: Why?',
        'diagram-hint': 'Reasons',
        'fixed-answer': 'Paper is still superior to screens as a medium for reading and understanding',
        'element_3_1': 'Easier to create a coherent mental map of the text',
        'element_3_2': 'Easier to become emotionally absorbed',
        'element_3_3': 'Easier to remember what you read',
        'element_3_4': 'Easier to tell where you are in the book',
        'element_3_5': 'Easier to read and understand',
        'element_3_6': 'Easier to navigate',
        'complete-title': 'Reveal',
        'hint-title': 'Hint',
        'resubmit-title': 'Resubmit',
        'next-title': 'Next',
        'hide-title': 'Hide',
        'answer_3_1': 'Easier to create a coherent mental map of the text',
        'answer_3_2': 'Easier to tell where you are in the book',
        'answer_3_3': 'Easier to become emotionally absorbed',
        'answer_3_4': 'Easier to remember what you read',
        'answer_3_5': 'Easier to read and understand',
        'answer_3_6': 'Easier to navigate',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b2/diagram3/i18n/en.js